import styled from 'styled-components';

export const ActivityLinkWrapper = styled.div`
  color: ${({ theme }) => theme.colors.green6};
  font-weight: 600;
  line-height: 20px;
`;
